console.log('Vastu Admin JS loaded!');

const SITE_KEY = '411998a29f2746b7737bccff0ee517bf'
let userDetailsApi = false;

const API_BASE_URL = 'https://live-vastu-backend.onrender.com';
let questionsTable = null;

function initializeDataTable() {
    if (questionsTable) {
        questionsTable.destroy();
    }
    
    questionsTable = $('#questionsTable').DataTable({
        columns: [
            { data: 'display_order' },
            { data: 'question_text' },
            { data: 'question_type' },
            { 
              data: 'question_plan',    
            },
            { 
                data: 'is_active',
                render: function(data) {
                    return data ? 
                        '<span style="color: green; font-weight: bold;">Active</span>' : 
                        '<span style="color: red; font-weight: bold;">Inactive</span>';
                }
            },
            {
                data: null,
                render: function(data, type, row) {
                       // change button color based on status
        const statusButtonText = row.is_active ? 'Deactivate' : 'Activate';
        const statusButtonColor = row.is_active ? 'btn-warning' : 'btn-success';
                    return `
                        <button class="btn btn-primary" onclick="editQuestion('${row._id}')">Edit</button>
                        <button class="btn ${statusButtonColor}" onclick="toggleQuestionStatus('${row._id}', ${row.is_active})">${statusButtonText}</button>
                        <button class="btn btn-danger" onclick="deleteQuestion('${row._id}')">Delete</button>
                    `;
                }
            }
        ]
    });
}

// Load questions from db
async function loadQuestions() {
    try {
        
        
        document.getElementById('admin-content').innerHTML = `
            <div style="background: #f8f9fa; padding: 15px; border-radius: 5px;">
                <p>Loading questions from backend...</p>
            </div>
        `;

        const response = await fetch(`${API_BASE_URL}/api/admin/questions`,{
            headers:{
                  "x-site-key": SITE_KEY
            }
        });
        const result = await response.json();
        
        if (result.success) {
            //  table container
            document.getElementById('questionsTableContainer').style.display = 'block';
            
            // Initialize or refresh DataTable
            if (!questionsTable) {
                initializeDataTable();
            }
            
            // Clear and add data
            questionsTable.clear();
            questionsTable.rows.add(result.data);
            questionsTable.draw();
            
            document.getElementById('admin-content').innerHTML = `
                <div style="background: #e7f3ff; padding: 15px; border-radius: 5px; margin-bottom: 20px;">
                    <p><strong> ${result.data.length}</strong> questions Loaded.</p>
                </div>
            `;
            
        } else {
            throw new Error(result.message);
        }
        
    } catch (error) {
        console.error('Error loading questions:', error);
        document.getElementById('admin-content').innerHTML = `
            <div style="background: #ffe7e7; padding: 20px; border-radius: 5px;">
                <h3>Connection Error</h3>
                <p>Error: ${error.message}</p>
               
            </div>
        `;
    }
}

// change active/inactive status
async function toggleQuestionStatus(id, currentStatus) {
    const newStatus = !currentStatus;
    const action = newStatus ? 'activate' : 'deactivate';
    
    if (confirm(`Are you sure you want to ${action} this question?`)) {
        try {
           
            
            const response = await fetch(`${API_BASE_URL}/api/admin/questions/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                      "x-site-key": SITE_KEY
                },
                body: JSON.stringify({
                    is_active: newStatus
                   
                })
            });
            
            const result = await response.json();
            
            if (result.success) {
               
                loadQuestions();
                alert(`Question ${action}d successfully!`);
            } else {
                alert('Error updating question: ' + result.message);
            }
        } catch (error) {
            console.error('Error updating question:', error);
            alert('Error updating question: ' + error.message);
        }
    }
}

// Edit question - open modal with existing data
async function editQuestion(id) {
    try {
       
        
        // Fetch question data from api
        const response = await fetch(`${API_BASE_URL}/api/questions/${id}`,{
            headers:{
                  "x-site-key": SITE_KEY
            }
        });
        const result = await response.json();
        
        if (result.success) {
            const question = result.data;
            
            // Fill form with existing data
            document.getElementById('questionText').value = question.question_text;
            document.getElementById('questionKey').value = question.question_key || "";
            document.getElementById('parentKey').value = question.parent_key || "";
            document.getElementById('subOrder').value = question.sub_order || "";
            document.getElementById('questionPlan').value = question.question_plan;
            document.getElementById('displayOrder').value = question.display_order;
            document.getElementById('isActive').checked = question.is_active;
            
            // Set options if multiple choice
            if (question.options && question.options.length > 0 && question.question_type == 'multiple_choice') {
                document.getElementById('questionOptions').value = question.options.join(', ');
            } else {
                document.getElementById('questionOptions').value = '';
            }
            
            // Store the question ID 
            document.getElementById('questionForm').dataset.editingId = id;
            
            // Update modal title
            document.querySelector('#questionModal h3').textContent = 'Edit Question';
            
            // Show/hide options based on type
            toggleOptions();
            
            // Open modal
            document.getElementById('questionModal').style.display = 'block';
            
        } else {
            alert('Error loading question: ' + result.message);
        }
    } catch (error) {
        console.error('Error loading question:', error);
        alert('Error loading question: ' + error.message);
    }
}

// Delete question
async function deleteQuestion(id) {
    if (confirm('Are you sure you want to delete this question?')) {
        try {
           
            
            const response = await fetch(`${API_BASE_URL}/api/admin/questions/${id}`, {
                method: 'DELETE',
                headers:{
                      "x-site-key": SITE_KEY
                }
            });
            
            const result = await response.json();
            
            if (result.success) {
                // Refresh the table to show updated data
                loadQuestions();
                alert('Question deleted successfully!');
            } else {
                alert('Error deleting question: ' + result.message);
            }
        } catch (error) {
            console.error('Error deleting question:', error);
            alert('Error deleting question: ' + error.message);
        }
    }
}

function openAddModal() {
    console.log('Opening add modal');
    document.getElementById('questionModal').style.display = 'block';
    document.getElementById('questionForm').reset();
    
    // Clear data id
    delete document.getElementById('questionForm').dataset.editingId;
    document.querySelector('#questionModal h3').textContent = 'Add New Question';
    
    // Show options by default
    document.getElementById('optionsGroup').style.display = 'block';
}

function closeModal() {
    console.log('Closing modal');
    document.getElementById('questionModal').style.display = 'none';
    
    // Clear data id
    delete document.getElementById('questionForm').dataset.editingId;
}

// Toggle options for type of questions
function toggleOptions() {
  const questionType = document.getElementById('questionType').value;
  const optionsGroup = document.getElementById('optionsGroup');
  
  if (questionType === 'multiple_choice') {
    optionsGroup.style.display = 'block';
  } else if (questionType === 'image_upload') {
    optionsGroup.style.display = 'none';
  } else {
    optionsGroup.style.display = 'none';
  }
}

async function handleFormSubmit(event) {
    event.preventDefault();
    console.log('Form submitted');
    
    // Get form data
    const questionData = {
        question_text: document.getElementById('questionText').value,
        question_type: document.getElementById('questionType').value,
        question_key: document.getElementById('questionKey').value,
        parent_key: document.getElementById('parentKey').value,
        question_plan: document.getElementById('questionPlan').value,
        display_order: parseInt(document.getElementById('displayOrder').value),
        sub_order: parseInt(document.getElementById('subOrder').value),
        is_active: document.getElementById('isActive').checked
    };

    // Add options if multiple choice
    if (questionData.question_type === 'multiple_choice') {
        const optionsText = document.getElementById('questionOptions').value;
        questionData.options = optionsText.split(',').map(opt => opt.trim()).filter(opt => opt);
    }

    try {
        const editingId = document.getElementById('questionForm').dataset.editingId;
        
        let response;
        if (editingId) {
            // Update existing question
           
            response = await fetch(`${API_BASE_URL}/api/admin/questions/${editingId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                      "x-site-key": SITE_KEY
                },
                body: JSON.stringify(questionData)
            });
        } else {
            // Create new question
            console.log('Creating new question');
            response = await fetch(`${API_BASE_URL}/api/admin/questions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                      "x-site-key": SITE_KEY
                },
                body: JSON.stringify(questionData)
            });
        }

        const result = await response.json();
        console.log(questionData);
        
        
        if (result.success) {
            // Success
            closeModal();
            loadQuestions(); 
            
            if (editingId) {
                alert('Question updated successfully!');
            } else {
                alert('Question created successfully!');
            }
        } else {
            alert('Error: ' + result.message);
        }
        
    } catch (error) {
        console.error('Error saving question:', error);
        alert('Error saving question: ' + error.message);
    }
}

async function fetchQuestions(planType = '') {
    let url = `${API_BASE_URL}/api/admin/questions`;

    if (planType) {
        url += `/${planType}`;
    }

   await fetch(url,{headers:{"x-site-key": SITE_KEY}})
        .then(res => res.json())
        .then(result => {
                if (!questionsTable) {
                initializeDataTable();
            }
            
            // Clear and add data
            questionsTable.clear();
            questionsTable.rows.add(result.data);
            questionsTable.draw();
               document.getElementById('admin-content').innerHTML = `
                <div style="background: #e7f3ff; padding: 15px; border-radius: 5px; margin-bottom: 20px;">
                    <p><strong> ${result.data.length}</strong> questions Loaded.</p>
                </div>
            `;
        })
        .catch(err => console.error(err));
}

async function handleUserDetailsForm(){
    console.log(userDetailsApi);
    
    if(!userDetailsApi)
    {
        userDetailsApi = true
          const response = await fetch(`${API_BASE_URL}/api/form-type`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                      "x-site-key": SITE_KEY
                },
                body: JSON.stringify({
                    formType: this.value
                   
                })
            });
            
            const result = await response.json();
            if(result.success)
            {
                alert(result.message)
               document.querySelector('#userDetailsForm').value =  this.value  
            }
            else{
                alert(result.message)
            }
            userDetailsApi = false
    }
  
}




// On page loads
document.addEventListener('DOMContentLoaded',async function() {
    console.log('DOM loaded - initializing admin panel');
    toggleOptions()
    // load questions
    loadQuestions();

    document.getElementById('planFilter').addEventListener('change', function () {
    const selectedPlan = this.value;
    fetchQuestions(selectedPlan);
});


     // button click for create question
    document.getElementById('addQuestionBtn').addEventListener('click', openAddModal);
    
    // button click for toggle on question type
    document.getElementById('questionType').addEventListener('change', toggleOptions);
    
    // Add submit event to form
    document.getElementById('questionForm').addEventListener('submit', handleFormSubmit);

    // for user details form
    document.querySelector('#userDetailsForm').addEventListener('change',handleUserDetailsForm)

     const response = await fetch(`${API_BASE_URL}/api/form-type`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                      "x-site-key": SITE_KEY
                }
            });
            const result = await response.json();
            if(result.success)
            {
                document.querySelector('.userDetailsCon').style.display = 'block';
                document.querySelector('#userDetailsForm').value = result.formType;
            }
            
});